const rows = [
  { feature: "Earn rate", silver: "1x", gold: "1.25x", platinum: "1.5x", diamond: "2x" },
  { feature: "Welcome bonus", silver: "500 Petals", gold: "750 Petals", platinum: "1,000 Petals", diamond: "2,000 Petals" },
  { feature: "Birthday bonus", silver: "500 Petals", gold: "1,000 Petals", platinum: "2,500 Petals", diamond: "5,000 Petals" },
  { feature: "Anniversary bonus", silver: "500 Petals", gold: "1,000 Petals", platinum: "2,500 Petals", diamond: "5,000 Petals" },
  { feature: "Tier qualification (annual)", silver: "₹0", gold: "₹50,000+", platinum: "₹1,50,000+", diamond: "₹3,00,000+" },
  { feature: "Early check-in", silver: "—", gold: "On request", platinum: "✓", diamond: "✓" },
  { feature: "Late check-out", silver: "—", gold: "2 PM", platinum: "4 PM", diamond: "Guaranteed" },
  { feature: "Suite upgrade (on availability)", silver: "—", gold: "—", platinum: "✓", diamond: "✓" },
  { feature: "Complimentary spa ritual", silver: "—", gold: "—", platinum: "—", diamond: "✓" },
  { feature: "Festive hampers", silver: "—", gold: "—", platinum: "✓", diamond: "✓ Premium" },
];

export default function LoyaltyBenefits() {
  return (
    <div className="max-w-[1300px] mx-auto px-6 lg:px-12 py-20" data-testid="page-benefits">
      <div className="text-[11px] uppercase tracking-[0.3em] kazo-text-burgundy mb-4">THE BENEFITS</div>
      <h1 className="editorial-headline text-5xl lg:text-7xl mb-12">Compare<br /><em className="font-light">your tier.</em></h1>
      <div className="overflow-x-auto bg-white border border-black/10">
        <table className="data-table min-w-[800px]">
          <thead>
            <tr>
              <th className="!bg-black !text-white">FEATURE</th>
              <th className="!bg-black !text-white text-center">SILVER</th>
              <th className="!bg-black !text-white text-center">GOLD</th>
              <th className="!bg-black !text-white text-center">PLATINUM</th>
              <th className="!bg-black !text-white text-center">DIAMOND</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.feature}>
                <td className="font-medium">{r.feature}</td>
                <td className="text-center">{r.silver}</td>
                <td className="text-center">{r.gold}</td>
                <td className="text-center">{r.platinum}</td>
                <td className="text-center font-semibold kazo-text-burgundy">{r.diamond}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
